import { Pipe, PipeTransform } from '@angular/core';
import { MorphologyTrait } from 'src/app/ricerca/interfaces/semantic-group-textual-forms.model';

@Pipe({
  name: 'morphologyTooltip'
})
export class MorphologyTooltipPipe implements PipeTransform {

  transform(morphList: MorphologyTrait[]): string {
    let result = '';
    for(let morph of morphList) {
      result = result + morph.value + ' - '
    }
    if(result !== '') {
      result = result.substring(0,result.length - 3);
    }
    return result;
  }

}
